var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "onboarding", staticClass: "emd-onboarding" },
    _vm._l(_vm.onboarding, function (item, i) {
      return _c(
        "div",
        {
          key: item.id,
          ref: item.id,
          refInFor: true,
          staticClass: "emd-onboarding__wrapper",
          class: { "eu-display_none": i !== _vm.step },
        },
        [
          _c("emd-pulse", {
            class: item.pulseDirection,
            attrs: { color: "secondary" },
          }),
          _c("div", { staticClass: "emd-container _content_spaced" }, [
            _c(
              "div",
              [
                _c("emd-status-bar", { attrs: { status: "secondary" } }),
                _c(
                  "div",
                  {
                    staticClass:
                      "emd-container__header eu-justify_end eu-align-items_start",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "emd-btn _type_link _color_contrast",
                        on: { click: _vm.close },
                      },
                      [_c("i", { staticClass: "uil uil-times" })]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "emd-container__content eu-align_center" },
              [
                item.hasImage
                  ? _c(
                      "div",
                      { staticClass: "emd-onboarding__image" },
                      [
                        _c("emerald-icon", {
                          attrs: { icon: `onboarding/${item.id}` },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "emd-text _color_default" }, [
                  _c(
                    "h2",
                    { staticClass: "emd-text _size_page _color_default" },
                    [
                      item.showStepNumber
                        ? _c("span", [_vm._v(_vm._s(i + 1) + ". ")])
                        : _vm._e(),
                      _vm._v(_vm._s(_vm.$t(`${item.id}.title`)) + " "),
                    ]
                  ),
                  _c("div", { staticClass: "eu-my_5" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(`${item.id}.text`, {
                            account: _vm.account,
                            url: _vm.docsUrl,
                          })
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "emd-container__footer eu-align_center eu-mb_3" },
              [
                item.showStepNumber
                  ? [
                      _c("div", { staticClass: "eu-container" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "eu-flex eu-justify_space-between eu-mb_3 eu-px_4",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "emd-btn _color_secondary _type_link",
                                attrs: { disabled: i === 0 },
                                on: {
                                  click: function ($event) {
                                    return _vm.goToStep(i - 1)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("previous")) + " ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "emd-btn _color_secondary _type_link",
                                on: {
                                  click: function ($event) {
                                    return _vm.goToStep(i + 1)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      i < _vm.totalSteps - 1
                                        ? _vm.$t("next")
                                        : _vm.$t("conclude")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _c("emd-progress-indicator", {
                        attrs: {
                          size: "small",
                          color: "tertiary",
                          interactive: "",
                          totalSteps: _vm.totalSteps,
                          currentStep: i + 1,
                        },
                        on: { goToStep: _vm.goToStep },
                      }),
                    ]
                  : _c(
                      "div",
                      { staticClass: "eu-flex eu-justify_end eu-mb_3 eu-px_4" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "emd-btn _color_secondary",
                            on: { click: _vm.close },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("ok")) + " ")]
                        ),
                      ]
                    ),
              ],
              2
            ),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }